export default __webpack_public_path__ + "files/media/plane.react.4e3866be.svg";